import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE, VIEW, EDIT } from "const"
import { mtGroupsRoute } from "client/parts/routes"
import { MtGroup, MtGroupCreate } from "server/models"
import {
    useInput,
    StateType,
    replaceHistoryState,
    forceRerenderContent,
} from "client/utils"
import {
    StoreType,
    GroupValidation,
    SaveGroup,
    closeModal,
    setGroupEdit,
    setGroupReloadList,
    setGroupReloadView,
    setGroupReloadEdit,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
    SpinnerIcon,
    Textarea,
} from "client/components"

interface EditGroupProps {
    group: MtGroup
}

let isMounted: boolean

const Form = ({
    group,
}: EditGroupProps) => {
    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(group.name)
    const [description, setDescription] = useInput(group.description)

    const [validation, setValidation] = useState<GroupValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return

        if (modals.length) {
            if (isMounted) dispatch(closeModal())
            return
        }

        const path = group.id
            ? `${mtGroupsRoute}/${VIEW}/${group.id}`
            : mtGroupsRoute

        forceRerenderContent(path, dispatch)
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newGroupData: MtGroupCreate = {
            accountId: group.accountId || userData.accountId,
            name,
            description,
            creator: group.creator || userData.userId,
        }

        SaveGroup(group.id, newGroupData, lang)
        .then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)

                if (res.newGroupId) replaceHistoryState(`${mtGroupsRoute}/${EDIT}/${res.newGroupId}`)
            }
            if (res.validation) return

            dispatch(setGroupEdit({
                id: res.newGroupId || group.id,
                ...newGroupData,
            }))

            dispatch(setGroupReloadList(false))
            dispatch(setGroupReloadView(false))
            setTimeout(() => {
                dispatch(setGroupReloadList(true))
                dispatch(setGroupReloadView(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setGroupReloadEdit(false))
                setTimeout(() => {
                    dispatch(setGroupReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
